"use client";

import { useMutation, useQuery } from "@tanstack/react-query";
import { type Fatura } from "@FN";
import { apiClient, get, post, URL } from "@/_nucleo/api";

/**
 * -----------
 * GET - Obter Faturas
 * ----------
 */
const BASE_PATH = URL.in.API_FINANCEIRO_FATURAS;

async function fetchFinanceiroFaturas(): Promise<Fatura[] | null> {
  const { data } = await get<Fatura[]>(apiClient.internal, BASE_PATH);
  return data ?? null;
}

export function useFinanceiroFaturas() {
  return useQuery({
    queryKey: ["financeiro", "faturas"],
    queryFn: fetchFinanceiroFaturas,
    staleTime: 5 * 60 * 1000,
  });
}

/**
 * -----------
 * POST - Deletar Fatura
 * ----------
 */

const DELETE_PATH = "rpws003/delprefat";
async function fetchDeletarFatura(Z15_COD: string, FILIAL: string): Promise<Fatura | null> {
  const { data } = await post<Fatura>(apiClient.production, `${DELETE_PATH}?DOC=${Z15_COD}&FILIAL=${FILIAL}`);
  return data ?? null;
}

export function useDeletarFatura() {
  return useMutation({
    mutationFn: ({ Z15_COD, FILIAL }: { Z15_COD: string; FILIAL: string }) =>
      fetchDeletarFatura(Z15_COD, FILIAL),
  })
}